import { Observable, Subscription, of, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { NavigationExtras, Router } from '@angular/router';

import { tapEx } from './helpers';
import { makeStateKey } from '@angular/core';

export interface IReturnData {
  route: any[];
  navigationExtras?: NavigationExtras;
  title: string;
}

export type StateKey = 'allrecentedocumenten'
  | 'recentedocumenten'
  | 'kalenderdata'
  | 'detailagendapuntdata'
  | 'agendapuntids'
  | 'recentebladwijzers'
  | 'detailzittingdata'
  | 'recentenotities'
  | 'soortenzitting'
  | 'partijen'
  | 'documentrefresh'
  | 'documentstate'
  | 'kalendarrefresh'
  | 'calendarstate'
  | 'zoekresultaten'
  | 'soortzittinggroeperingids'
  | 'searchoptions'
  | 'prikborddata'
  | 'notitiereturnroute'
  | 'zittingarchiefdata'
  | 'notitiesearchoptions'
  | 'notitiesearchresults'
  | 'documentzittingsearchoptions'
  | 'documentzittingsearchdata'
  ;

const zoekPageSize = 20;
// class StateService {
//     private _stateMap: Map<string, any>;

//     constructor() {
//         console.log('creating stateservice');
//         this._stateMap = new Map<string, any>();
//     }

//     renewSubscription(key: StateKey, subscriptionFn: () => Subscription) {
//         if (this._stateMap.has(key)) {
//             const s = this._stateMap.get(key) as Subscription;
//             s.unsubscribe();
//         }
//         const subscription = subscriptionFn();
//         this.add(key, subscription);
//         return subscription;
//     }


//     add(name: StateKey, value: any) {
//         this._stateMap.set(name, value);
//     }
//     remove(name: StateKey) {
//         this._stateMap.delete(name);
//     }

//     get<T>(name: StateKey, defaultValue: T = undefined) {
//         const value: T = this._stateMap.get(name);
//         this._stateMap.set(name, value || defaultValue);
//         return this._stateMap.get(name);
//     }
//     has(name: StateKey): boolean {
//         return this._stateMap.has(name);
//     }

//     subscribe(name: StateKey, source$: Observable<any>) {
//         source$.subscribe(data => this.add(name, data));
//     }

//     log<T>(key: StateKey, arg: T): T {
//         console.log(`state ${key} refreshed`);
//         return arg;
//     };

//     public getObservable<T>(key: StateKey, fn: () => Observable<T>, force: boolean = false): Observable<T> {
//         return this.getObservableInternal(key, fn, force);
//     }

//     private getObservableInternal<T>(key: StateKey | string, fn: () => Observable<T>, force: boolean = false): Observable<T> {
//         const value: T = this._stateMap.get(key);
//         return value && !force
//             ? of(value)
//             : fn().map(value => { this._stateMap.set(key, value); return value; });
//     }
//     getObservableSubkey<T>(key: StateKey, subkey: string, fn: () => Observable<T>, force: boolean = false): Observable<T> {
//         const fullkey = `${key}${subkey}`;
//         return this.getObservableInternal(fullkey, fn, force);
//     }

//     areEqual(first: any[], second: any[]) {
//         if (!first) {return false;}
//         for (let index = 0; index < first.length; index++) {
//             if (first[index] !== second[index]) {return false;}
//         }
//         return true;
//     }
//     getObservableFromId<T>(key: StateKey, ids: any[], fn: () => Observable<T>, force: boolean = false): Observable<T> {
//         const oldids: any[] = this._stateMap.get(key + 'ids');
//         const fromCache = !force && this.areEqual(oldids, ids);
//         if (fromCache) {
//             const value: T = this._stateMap.get(key);
//             return of(value);
//         } else {
//             this._stateMap.set(key + 'ids', ids);
//             return fn().map(value => { this._stateMap.set(key, value); return value; });
//         }
//     }
//     getObservableConcatFromId<T>(key: StateKey, ids: any[], fn: () => Observable<T>, force: boolean = false): Observable<T> {
//         const oldids: any[] = this._stateMap.get(key + 'ids');
//         const fromCache = !force && this.areEqual(oldids, ids);
//         if (fromCache) {
//             const value: T = this._stateMap.get(key);
//             return of(value);
//         } else {
//             this._stateMap.set(key + 'ids', ids);
//             return fn().map(value => {
//                 const newValue = (this._stateMap.get(key) || []).concat(value);
//                 this._stateMap.set(key, newValue);
//                 return newValue;
//             });
//         }
//     }


// }

export const cacheTimeMax = Number.MAX_VALUE;
export const cacheTimeDefault = 300000; // 5min

export interface IStateOptions {
  allowFromCache: boolean;
  concat: boolean;
  cacheTime: number;
}
export interface IStateOptions2 {
  allowFromCache?: boolean;
  concat?: boolean;
  cacheTime?: number;
  pageSize?: number;
  page?: number;
  addToHistory?: boolean;
}

class State2Service {

  private stateMap: Map<string, any>;
  private cacheTimeMap: Map<string, number>;
  private returnData: IReturnData[];
  constructor() {
    this.stateMap = new Map<string, any>();
    this.cacheTimeMap = new Map<string, number>();
    this.returnData = [];
  }
  notRefreshable: StateKey[] = ['soortenzitting', 'partijen', 'notitiereturnroute'];

  clear() {
    //console.log('clearing state');
    const keys = Array.from(this.stateMap.keys());
    const refreshableKeys = keys.filter((k: StateKey) => !this.notRefreshable.includes(k));
    refreshableKeys.forEach(k => this.stateMap.delete(k));
  }
  getValue<T>(key: StateKey) {
    return this.stateMap.get(key);
  }

  // cacheTime >0 cache result during time
  // cacheTime =0 do not cache
  // cacheTime =-1 cache indefinitely
  getValueOrDefault<T>(key: StateKey, defaultValue: Observable<T>, cacheTime = cacheTimeDefault, concat = false) {
    const isExperid = this.getIsExpired(key, cacheTime);
    const allowFromCache = !isExperid && !concat;
    const data: T = this.stateMap.get(key);
    if (data !== undefined && allowFromCache) {
      //console.log(`${key} from cache`);
      return of(data);
    }
    //console.log(`${key} not from cache`);
    return defaultValue.pipe(
      map(result => {
        this.stateMap.set(key, result);
        this.cacheTimeMap.set(key, new Date().getTime());
        return result;
      })
    );
  }


  getIsExpired(key: StateKey, cacheTime: number) {
    const now = new Date().getTime();
    const last = this.cacheTimeMap.get(key) || 0;
    return now - last > cacheTime;
  }

  getArrayOrDefault<T>(key: StateKey, defaultValue: Observable<Array<T>>, options: IStateOptions): Observable<Array<T>> {
    const isExpired = this.getIsExpired(key, options.cacheTime);
    const allowFromCache = !isExpired && options.allowFromCache && !options.concat;
    const data: Array<T> = this.stateMap.get(key);
    if (data !== undefined && allowFromCache) { return of(data); }
    return defaultValue.pipe(
      tapEx('request'),
      map(result => {
        const newresult: Array<T> = options.concat ? data.concat(result) : result;
        this.stateMap.set(key, newresult);
        this.cacheTimeMap.set(key, new Date().getTime());
        return newresult;
      })
    );
  }

  getSearchResultOrDefault<Titem>(key: StateKey, defaultValue: Observable<Array<Titem>>, options: IStateOptions2): Observable<ISearchResult<Titem>> {
    const isExperid = this.getIsExpired(key, options.cacheTime);
    const allowFromCache = !isExperid && options.allowFromCache; // && !options.concat;
    const searchResult: ISearchResult<Titem> = this.stateMap.get(key);

    if (searchResult !== undefined && allowFromCache) { return of(searchResult); }
    return defaultValue.pipe(
      map(result => {
        const newresult: ISearchResult<Titem> = {
          page: options.page,
          hasMoreResults: result.length === zoekPageSize,
          items: options.concat ? searchResult.items.concat(result) : result
        };
        this.stateMap.set(key, newresult);
        this.cacheTimeMap.set(key, new Date().getTime());
        return newresult;
      })
    );
  }

  getSubValueOrDefault<T>(key: StateKey, subkey: string | Date | number, defaultValue: Observable<T>, cacheTime = cacheTimeDefault) {
    const subkeyString = this.getSubKeyString(subkey);
    return this.getValueOrDefault(`${key}_${subkeyString}` as StateKey, defaultValue, cacheTime);
  }
  getSubKeyString(subkey: string | Date | number) {
    return typeof (subkey) === 'string' ? subkey
      : subkey instanceof Date ? subkey.getTime().toString()
        : subkey.toString();
  }
  hasValue<T>(key: StateKey) {
    return this.stateMap.has(key);
  }
  getSubkeyValue<T>(key: StateKey, subkey: string | Date | number): T {
    return this.getValue(`${key}_${this.getSubKeyString(subkey)}` as StateKey);
  }
  setSubkey(key: StateKey, subkey: number | string | Date, value: any) {
    this.set(`${key}_${this.getSubKeyString(subkey)}` as StateKey, value);
  }
  set(key: StateKey, value: any) {
    this.stateMap.set(key, value);
    // if (key==='notitiereturnroute') {
    //     console.log(value);
    // }
  }

  /**
   * updates key with partial value
   *
   */
  update(key: StateKey, value: any) {
    const newValue = { ...this.stateMap.get(key), ...value };
    this.stateMap.set(key, newValue);
  }
  remove(key: StateKey) {
    this.stateMap.delete(key);
  }
  removeSubKey(key: StateKey, subkey: string | number | Date) {
    const subkeyString = this.getSubKeyString(subkey);
    this.stateMap.delete(`${key}_${subkeyString}`);
  }

  renewSubscription(key: StateKey, subscriptionFn: () => Subscription) {
    if (this.stateMap.has(key)) {
      const s = this.stateMap.get(key) as Subscription;
      s.unsubscribe();
    }
    const subscription = subscriptionFn();
    this.stateMap.set(key, subscription);
    return subscription;
  }
  getSimpleValueOrDefault<T>(key: StateKey, defaultValue: T): T {
    return this.stateMap.get(key) || defaultValue;
  }
  static maxHistoryLength = 10;
  pushReturnData(returnData: IReturnData) {
    if (this.returnData.length === State2Service.maxHistoryLength) {
      this.returnData.splice(0, 1);
    }
    this.returnData.push(returnData);
  }
  popReturnData(defaultReturnData: IReturnData = null) {
    return this.returnData.length ? this.returnData.pop() : defaultReturnData;
  }
  getCurrentReturnData(defaultReturnData = null) {
    return this.returnData.length ? this.returnData[this.returnData.length - 1] : defaultReturnData;
  }
  navigateBack(router: Router) {
    const returnData = this.popReturnData();
    router.navigate(returnData.route, returnData.navigationExtras);
  }

  historyMap = new Map<string, IHistoryItem>();
  addToHistory(key: string, historyItem: IHistoryItem) {
    this.historyMap.set(key, historyItem);
  }
  removeFromHistory(key: string): string {
    const result = this.historyMap.get(key);
    this.historyMap.delete(key);
    return result.url;
  }
  getUrlFromHistory(key: string): string {
    return this.historyMap.get(key).url;
  }
  getHistoryItem(key: string): IHistoryItem {
    return this.historyMap.get(key);
  }

}

export interface IHistoryItem {
  url?: string;
  timestamp: Date;
  title: string;
  commands?: any[];
  extras?: NavigationExtras;
  doNotReplace?: boolean;
}

export interface ISearchResult<Titem> {
  hasMoreResults: boolean;
  page?: number;
  items: Titem[];
}

// export const state = new StateService();
export const state2 = new State2Service();


